"use strict";
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var _a, _UserConsentStatus_message;
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserConsentStatus = void 0;
const Common_1 = require("./Common");
/** Utility class for creating user consent related errors */
class UserConsentStatus {
    /**
     * Creates an instance of UserConsentStatus derived from the user consent data.
     * @param userConsent - user consent object
     * @internal
     */
    static from(userConsent) {
        const { preferences } = userConsent;
        const pendingUserAction = userConsent.userActionRequired || preferences.some(({ optIn }) => optIn == null);
        if (pendingUserAction)
            return new UserConsentStatus(Common_1.UserConsentStatusCode.userPendingAction);
        const userOptIn = preferences.some(({ optIn }) => !!optIn);
        if (!userOptIn)
            return new UserConsentStatus(Common_1.UserConsentStatusCode.userOptOut);
        return new UserConsentStatus(Common_1.UserConsentStatusCode.userOptIn);
    }
    /**
     * The message associated with this status instance.
     * You can use this to determine the type of user consent error.
     */
    get message() {
        return __classPrivateFieldGet(UserConsentStatus, _a, "f", _UserConsentStatus_message)[this.code];
    }
    /** @internal */
    constructor(code) {
        /** This code will be used when the user consent preferences contain at least one element with null as the optIn value. This indicates that the user has yet to make their select. */
        this.PENDING_USER_ACTION = Common_1.UserConsentStatusCode.userPendingAction;
        /** This code will be used when all the user consent preferences contain false as the optIn value. This indicates that the user has opted out of tracking. */
        this.USER_OPT_OUT = Common_1.UserConsentStatusCode.userOptOut;
        /** This code will be used when no user action is required, and has at least 1 preferences set to true. */
        this.USER_OPT_IN = Common_1.UserConsentStatusCode.userOptIn;
        this.code = code;
    }
}
_a = UserConsentStatus;
_UserConsentStatus_message = { value: {
        [Common_1.UserConsentStatusCode.userPendingAction]: Common_1.ERROR_MESSAGE.userConsentPendingUserAction,
        [Common_1.UserConsentStatusCode.userOptOut]: Common_1.ERROR_MESSAGE.userConsentOptOut,
        [Common_1.UserConsentStatusCode.userOptIn]: Common_1.ERROR_MESSAGE.userConsentOptIn,
    } };
exports.UserConsentStatus = UserConsentStatus;
